import React, { Component } from 'react';

class Resume extends Component {

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  render() {

    if(this.props.data){
      var education = this.props.data.education.map(function(education){
        return <div key={education.school}><h3>{education.school}</h3>
        <p className="info">{education.degree} <br/><em className="date">{education.graduated}</em></p>
        <p>{education.description}</p></div>
      })
      var work = this.props.data.work.map(function(work){
        return <div key={work.company}><h3>{work.company}</h3>
            <p className="info">{work.title}<br/> <em className="date">{work.years}</em><span>&#124;</span><em className="date">{work.place}</em></p>
            <p>{work.description1}</p>
            <p>{work.description2}</p>
            <p>{work.description3}</p>
            <p>{work.description4}</p>
        </div>
      })

      var certificates = this.props.data.certificates.map(function (certificates) {
          var badge = 'images/portfolio/' + certificates.badge;
          return <div key={certificates.company}>
          <h3><a href={certificates.url} target="_blank"><img className="badge"  alt={certificates.badge} src={badge} /></a><br /><a href={certificates.url} target="_blank">{certificates.title}</a></h3>
          <p className="info">{certificates.company} <br/><em className="date">{certificates.monthandyear}</em></p>
          <p>{certificates.description}</p>
          </div>
      })

      var appliedskills = this.props.data.appliedskills.map(function (appliedskills) {
        var badge = 'images/portfolio/' + appliedskills.badge;
        return <div key={appliedskills.company}>
        <h3><a href={appliedskills.url} target="_blank"><img className="badge" alt={appliedskills.badge} src={badge} /></a><br /><a href={appliedskills.url} target="_blank">{appliedskills.title}</a></h3>
        <p className="info">{appliedskills.company} <br/><em className="date">{appliedskills.monthandyear}</em></p>
        <p>{appliedskills.description}</p>
        </div>
    })

      var awards = this.props.data.awards.map(function(awards){
        return <div key={awards.school}><h3>{awards.school}</h3>
        <p className="info">{awards.degree} <br/><em className="date">{awards.graduated}</em><span>&#124;</span><em className="date">{awards.place}</em></p>
        <p>{awards.description}</p>
        <br/>
        </div>
      })

      var skills = this.props.data.skills.map((skills)=>{
        var className = 'bar-expand '+skills.name.toLowerCase();
        return (
          <li key={skills.name}>
            <span style={{width:skills.level, backgroundColor:this.getRandomColor()}}className={className}></span><em>{skills.name}</em>
          </li>
        )
      })

      var languages = this.props.data.languages.map((languages)=>{
        var className = 'bar-expand '+languages.name.toLowerCase();
        return (
          <li key={languages.name}>
            <span style={{width:languages.level, backgroundColor:this.getRandomColor()}}className={className}></span><em>{languages.name}</em>
          </li>
        )
      })
    }

    return (
      <section id="resume">

      <div className="row education">
         <div className="three columns header-col">
            <h1><span>Education</span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                 {education}
               </div>
            </div>
         </div>
      </div>


      <div className="row work">
        <div className="three columns header-col">
          <h1><span>Work</span></h1>
        </div>

        <div className="nine columns main-col">
          {work}
        </div>
      </div>

      <div className="row awards">
         <div className="three columns header-col">
            <h1><span>Certificates</span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                  {certificates}
               </div>
             </div>
         </div>
      </div>
            <br />


      <div className="row awards">
         <div className="three columns header-col">
            <h1><span>Applied Skills</span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                  {appliedskills}
               </div>
             </div>
         </div>
      </div>
            <br />


      <div className="row awards">
         <div className="three columns header-col">
            <h1><span>Awards</span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                 {awards}
               </div>               
            </div>
         </div>
      </div>

      <div className="row skill">
        <div className="three columns header-col">
          <h1><span>Skills</span></h1>
        </div>

        <div className="nine columns main-col">
				  <div className="bars">
				    <ul className="skills">
					    {skills}
					  </ul>
				  </div>
			  </div>
      </div>

      <div className="row languages">
        <div className="three columns header-col">
          <h1><span>Languages</span></h1>
        </div>

        <div className="nine columns main-col">

         <br/>

        <div className="bars">
            <ul className="languages">
              {languages}
            </ul>
          </div>
        </div>
      </div>
   </section>
    );
  }
}

export default Resume;



// WEBPACK FOOTER //
// ./src/Components/Resume.js